import { useAuth } from "@mindlercare/auth-ui";
import { RouterOutput } from "@mindlercare/mindlerapi-client";
import {
  CodeISO2,
  CountryId,
  codeISO2Schema,
  countries,
  countryIds,
} from "@mindlercare/schema";
import { useGetMarkets } from "../../api/markets";
import { getCountryCode } from "../../helpers/getCountryCode";

export const useCurrentMarketCode = (): CodeISO2 => {
  const { market } = useAuth();
  return market ?? getCountryCode() ?? codeISO2Schema.enum.SE;
};

export const useEnabledMarkets = () => {
  const { data = [] } = useGetMarkets();
  return data;
};

export const useSelectedMarket = () => {
  const markets = useEnabledMarkets();
  const { market } = useAuth();
  return (
    markets.find((m) => {
      const code = market ?? getCountryCode();
      return m.codeISO2 === code;
    }) ?? null
  );
};

export const useApplicationMarket = () => {
  const markets = useEnabledMarkets();
  return (
    markets.find((m) => m.codeISO2 === getCountryCode()) ??
    ({} as RouterOutput["application"]["markets"][0])
  );
};

export const useCurrentCountryId = () => {
  const selectedMarket = useSelectedMarket();
  return (selectedMarket?.countryId ??
    countryIds[getCountryCode()]) as unknown as CountryId;
};

export const useCurrentMarketName = () => {
  const selectedMarket = useSelectedMarket();
  return selectedMarket?.name ?? countries[getCountryCode()]?.name;
};

export const useIsSelectedMarketGB = () => {
  const selectedMarket = useSelectedMarket();
  return selectedMarket?.codeISO2 === "GB" || getCountryCode() === "GB";
};
